import * as Constants from "../constants";

const initialState = {
  allOfferTags: [],
  offers: {
    active: [],
    expired: [],
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.FETCH_OFFERS_START:
    case Constants.FETCH_ALL_OFFER_TAGS_START:
      return {
        ...state,
        offers: initialState.offers,
      };
    case Constants.FETCH_ALL_OFFER_TAGS_SUCCESS:
      const allTags = action.data.data;
      allTags.unshift("All");
      return {
        ...state,
        allOfferTags: allTags,
      };
    case Constants.FETCH_ALL_OFFER_TAGS_FAILURE:
      return {
        ...state,
        allOfferTags: [],
      };
    case Constants.FETCH_OFFERS_SUCCESS:
      return {
        ...state,
        offers: action.data.data,
      };
    case Constants.FETCH_ALL_OFFER_TAGS_FAILURE:
      return {
        ...state,
        offers: [],
      };
    default:
      return {
        ...state,
      };
  }
}
